import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardImg, CardText, CardBody, CardFooter, CardHeader, Row, Col , List} from 'reactstrap';
import { AiOutlineCheck, AiOutlineClose, AiFillCheckSquare, AiFillCloseSquare } from 'react-icons/ai';
import { ImCheckboxChecked, ImCheckboxUnchecked } from 'react-icons/im';
import url from "./variables/url.js";
import shark from './Imagenes/IconInsignias/shark.svg';
import sostenibilidad from './Imagenes/IconInsignias/ciudadania-ETICA.svg';
import liderazgo from './Imagenes/IconInsignias/liderazgo-AUTOAGENCIA.svg';
import creatibidad from './Imagenes/IconInsignias/CREATIVIDAD.svg';
import interaccion from './Imagenes/IconInsignias/interaccion-COMUNICACION.svg';
import autonomia from './Imagenes/IconInsignias/Autonomia-APRENDIZAJE.svg';
import estrategia from './Imagenes/IconInsignias/Gestion-ESTRATEGICA.svg';

import sostenibilidadAP from './Imagenes/IconInsignias/ciudadania-ETICA(B).svg';
import liderazgoAP from './Imagenes/IconInsignias/liderazgo-AUTOAGENCIA(B).svg';
import creatibidadAP from './Imagenes/IconInsignias/CREATIVIDAD(B).svg';
import interaccionAP from './Imagenes/IconInsignias/interaccion-COMUNICACION(B).svg';
import autonomiaAP from './Imagenes/IconInsignias/Autonomia-APRENDIZAJE(B).svg';
import estrategiaAP from './Imagenes/IconInsignias/Gestion-ESTRATEGICA(B).svg';

/*const localBack = url.localBack;*/
const localBack = process.env.REACT_APP_BACK;

const imgInsignia = [shark, sostenibilidad, liderazgo, creatibidad, interaccion, autonomia, estrategia];

const imgInsigniaAP = [shark, sostenibilidadAP, liderazgoAP, creatibidadAP, interaccionAP, autonomiaAP, estrategiaAP];

const colors = ['#FFFFFF', '#354750', '#F48700', '#A72186', '#1DA656', '#EA3B13','#1F58AB']


class InsigniaResultCard extends React.Component {
    constructor(props) {
        super(props);
        const {            
        } = props.insignia || {};

        //console.log(this.props.criterios);

        this.state = {
            tipos: [],
            insignia: [],
            criterios: this.props.criterios,
            resultados: this.props.insignia.criterio
        };
        this.populateInfoData();
    }

    componentDidMount() {
        this.populateInfoData();        
    }

    //static getDerivedStateFromProps(props) {
    //    this.setState({ insignia: props.insignia, criterios: props.criterios, tipos: [], insignia: [] });
    //    this.populateInfoData();
    //}

    render() {
        let check = this.orderAndSecuence(this.state.criterios, this.props.insignia.idaexinsignia);
        return (
            <div id={"insignia-" + this.props.insignia.idaexresultadoinsignia} className="InsigniaResult-card py-1" style={{ height: "100%" }}>
                <Card style={{ borderColor: '#333', height: "100%" }} >
                    <CardHeader style={this.props.insignia.resultado >= this.props.insignia.totalacumplir ? { color: colors[0], backgroundColor: colors[this.props.insignia.idaexinsignia], borderColor: '#333' } : { color: '#717D81', backgroundColor: colors[0], borderColor: '#333' }}>
                        <div className="expense">
                            <Row>
                                <img src={this.props.insignia.resultado >= this.props.insignia.totalacumplir ? imgInsignia[this.props.insignia.idaexinsignia] : imgInsigniaAP[this.props.insignia.idaexinsignia]} style={{ width: "10%", height: "5%" }} />
                            &nbsp;
                                <span  ><strong>{this.props.insignia.insignia.nombre}</strong></span>
                            </Row>
                        </div>
                    </CardHeader>
                    <CardBody>                        
                        <CardText >Actividades Aprobadas:</CardText>
                        {this.state.criterios.filter(c => c.criterio.idaexinsignia === this.props.insignia.idaexinsignia).map((resultado, i, list) => {
                            if (this.props.insignia.idaexinsignia == resultado.criterio.idaexinsignia) {                                
                                return (
                                    <CardText key={i}>
                                        {i > 0 && resultado.criterio.orden === list[i - 1].criterio.orden ? <strong>O</strong> : check.includes(resultado.criterio.orden) ? <ImCheckboxChecked color="green" /> : <ImCheckboxUnchecked color="black" /> }
                                        &nbsp;{resultado.criterio.descripcion}
                                        &nbsp;<strong>({resultado.resultado == null ? 0 : resultado.resultado > resultado.criterio.valor ? resultado.criterio.valor : resultado.resultado}/{resultado.criterio.valor})</strong>
                                    </CardText>
                                )
                            }                                
                        }
                        )}
                    </CardBody>
                    <CardFooter className="text-muted">
                    </CardFooter>
                </Card>
            </div>
        )
    }

    populateInfoData() {
        fetch(localBack + '/api/Insignia', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => response.json())
            .then(data => {
                /*console.log(data);*/
                this.setState({
                    insignias: data.objDatos
                });
            });

        fetch(localBack + '/api/TipoActividad', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => response.json())
            .then(data => {
                /*console.log(data);*/
                this.setState({
                    tipos: data.objDatos                    
                });
            });
    }

    orderAndSecuence(criterios, idaexinsignia) {
        let result = [];
        let verdaderos = [];
        let check = [];
        criterios.filter(c => c.criterio.idaexinsignia === idaexinsignia).map(act => { result.push(act) });      
        result.map((c, i, list) => {
            check.push({ 'orden': c.criterio.orden, 'valor': c.resultado >= c.criterio.valor });
        });
        check.filter(c => c.valor === true).map(c => { verdaderos.push(c.orden) });        
        return verdaderos;
    }
    
}

InsigniaResultCard.propTypes = {
    insignia: PropTypes.shape({        
            idaexresultadoinsignia: PropTypes.number.isRequired,
            idaexinsignia: PropTypes.number.isRequired,
            resultado: PropTypes.number.isRequired,
            totalacumplir: PropTypes.number.isRequired,
            insignia: PropTypes.shape({
                idaexinsignia: PropTypes.number.isRequired,
                nombre: PropTypes.string.isRequired,
                descripcion: PropTypes.string.isRequired
            }).isRequired,                        
    }).isRequired,
    criterios: PropTypes.arrayOf(PropTypes.shape({
        idaexresultadocriterio: PropTypes.number.isRequired,
        idaexcriterio: PropTypes.number.isRequired,
        idestudiante: PropTypes.number.isRequired,
        resultado: PropTypes.number.isRequired,
        criterio: PropTypes.shape({
            idaexcriterio: PropTypes.number.isRequired,
            idaexinsignia: PropTypes.number.isRequired,
            idaextipoactividad: PropTypes.number.isRequired,
            orden: PropTypes.string.isRequired,
            secuencia: PropTypes.string.isRequired,
            descripcion: PropTypes.string.isRequired,
            operacion: PropTypes.string.isRequired,
            valor: PropTypes.number.isRequired,
            estado: PropTypes.string.isRequired,
        }).isRequired
    })).isRequired,
};

//idaexresultadoinsignia: 1,
//    idaexinsignia: 1,
//        nombre: "Ciudadan�a y �tica para la sostenibilidad",
//            idestudiante: 0,
//                resultado: 3,
//                    totalacumplir: 5,
//                        insignia: { },
//criterios: { }

export default InsigniaResultCard;
